import "./style.scss";
import $ from "jquery";
console.log("test3");
$('.image-with-hot-spots').find('.hot-spot').click(function(){
    console.log("test");
    if ($(this).hasClass( "active" )) {
        $('.hot-spot').removeClass("active");
        $('.hot-spots-mobile .hot-spot-mobile-wrap').hide();
    }
    else {
        console.log("test2");
        let hotspot = "#"+$(this).data("id");
        console.log(hotspot);
        $('.hot-spot').removeClass("active");
        $('.hot-spots-mobile .hot-spot-mobile-wrap').hide()
        $(this).addClass("active");
        $(hotspot).show();
    }
});